import FJCanvasPool from '../FJCanvasPool';
import FJRender from './FJRender';

class FJSvgExporter {
    _curFrameIdx = 0;
    _endFrameIdx = 0;
    _renderingCnt = 0;
    _frames = [];
    _callback = null;

    /**
     * @desc
     * @param props
     */
    constructor(callback) {
        this._callback = callback;
    }

    /**
     * @desc svg转图片
     * @param svgStr
     * @param frameData
     */
    svgToImage(svgStr, frameData = null) {
        const index = this._frames.length;
        this._frames[index] = {
            image: null,
            status: 'rendering',
            data: frameData,
        };
        this._renderingCnt++;

        this._loadSvgToImage(
            svgStr,
            image => {
                if (!this._frames[index]) return;

                this._renderingCnt--;
                this._frames[index].status = 'done';
                this._frames[index].image = image;

                this._outputImage();
            },
            e => {
                if (!this._frames[index]) return;

                this._renderingCnt--;
                this._frames[index].status = 'error';
                this._frames[index].errMsg = 'svg image load error';

                this._callback(null, e.message, null);
            },
        );
    }

    /**
     * @desc 输出图片
     * @private
     */
    _outputImage() {
        if (this._callback === null) return;

        if (this._frames.length > this._curFrameIdx) {
            const frame = this._frames[this._curFrameIdx];
            const { image, status, errMsg, data } = frame;

            if (status === 'done') {
                this._frames[this._curFrameIdx] = null;
                this._curFrameIdx++;
                this._callback(image, null, data);

                this._outputImage();
            } else if (status === 'error') {
                this._callback(null, errMsg, data);
            }
        }
    }

    /**
     * @desc 开始导出
     */
    start() {
        this._renderingCnt = 0;
        this._curFrameIdx = 0;
        this._endFrameIdx = Infinity;
        this._startTime = performance.now();
    }

    /**
     * @desc 标记结束导出
     */
    end() {
        this._endFrameIdx = this._frames.length;
    }

    /**
     * @desc 是否结束
     * @returns {boolean}
     */
    isEnd() {
        return this._curFrameIdx >= this._endFrameIdx;
    }

    /**
     * @desc 是否可以导出, 最多同时导出10个
     * @returns {boolean}
     */
    canExport() {
        return this._renderingCnt < 10;
    }

    /**
     * @desc 清空
     */
    clear() {
        this._frames.forEach(frame => {
            if (frame && frame.image) {
                FJCanvasPool.releaseCanvas(frame.image);
            }
        });
        this._frames = [];

        this._callback = null;
    }

    /**
     * @desc 加载svg到image
     * @param svgStr
     * @param imageSuccess
     * @param imageError
     * @private
     */
    _loadSvgToImage(svgStr, imageSuccess, imageError) {
        FJRender.loadSvgToImage(svgStr).then(imageSuccess).catch(imageError);
    }
}

export default FJSvgExporter;
